import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.ru.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

export default (function () {
    var option={language: 'ru'};
    $('[data-provide=datepicker]').datepicker(option);

    function initDatapickerRange(){
        $('.start__date').datepicker(option).on('changeDate',function(e){
            var $this=$(this);
            $this.parents('.datapicker__range').find('.end__date').datepicker('setStartDate',$this.val());
        });

        $('.end__date').datepicker(option).on('changeDate',function(e){
            var $this=$(this);
            $this.parents('.datapicker__range').find('.start__date').datepicker('setEndDate',$this.val());
        });
    }
    initDatapickerRange();



}())
